import React, { useEffect, useState, useRef } from 'react';
import Skeleton from 'react-loading-skeleton';

import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Collapse from '@material-ui/core/Collapse';

import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import EditIcon from '@material-ui/icons/Edit';
import { CardContent, Typography } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import Chip from '@material-ui/core/Chip';
import { green, red } from '@material-ui/core/colors';

import NotificationsService from './../../../services/api/notifications';

const useStyles = makeStyles({
  th: {
    fontWeight: 'bolder',
    textTransform: 'uppercase',
  },
  searchIcon: {
    marginRight: '16px',
  },
  paper: {
    height: '42px',
    display: 'flex',
    padding: '0px 16px',
    alignItems: 'center',
  },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: '1',
  },
  searchButton: {
    marginLeft: '16px',
    marginRight: '5px',
  },
  searchContainer: {
    marginBottom: '1em',
  },
  cardContent: {
    paddingBottom: '1em !important',
  },
  chipActive: {
    backgroundColor: green[100],
    color: green[700],
  },
  chipInactive: {
    backgroundColor: red[100],
    color: red[700],
  },
  paginatorContainer: {
    marginTop: '1em',
  },
  filtersBox: {
    marginBottom: '-30px',
  },
  filterBtn: {
    marginTop: '3px',
  },
  table: {
    overflowX: 'auto',
    marginRight: 'auto',
    marginLeft: 'auto',
  },
});

export const NotificationsList = () => {
  const classes = useStyles();

  const [state, setState] = useState({status: ''});

  const [notifications, setNotifications] = React.useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [initialNotifications, setInitialNotifications] = React.useState([]);

  const [filters, setFilters] = React.useState(false);
  const [searchStatus, setSearchStatus] = React.useState(false);

  const searchInput = useRef();

  useEffect(() => {
    setIsLoading(true);

    setTimeout(function () {
      //Request
      NotificationsService.getList()
        .then((response) => {
          if (response === null || !response.IsValid) {
            throw response.Message;
          }
          setIsLoading(false);
          //Get Notifications
          if (response && response.Data && response.Data.length > 0) {
            setNotifications(response.Data);
            setInitialNotifications(response.Data);
            setIsLoading(false);
          }
        })
        .catch((e) => {
          setIsLoading(false);
        });
    }, 1000);
  }, []);

  const handleFilters = (event) => {
    setFilters(filters ? false : true);
  };

  const handleChange = (event) => {
    // const name = event.target.name;
    // setState({
    //   ...state,
    //   [name]: event.target.value,
    // });
  };

  const findVehicle = () => {
    let resultSet = [];

    if(searchInput.current.value === ''){
      clearSearchField();
      return;
    }

    for (var i = 0; i < initialNotifications.length; i++){
      if (initialNotifications[i].Titulo.search(searchInput.current.value) !== -1){
        resultSet = [...resultSet, ...[initialNotifications[i]]]
      }
    }
    setNotifications(resultSet)
    setSearchStatus(true);
  }

  const findVehicleKey = (e) => {
    if (e.charCode === 13) {
      findVehicle();
    }
  }

  const clearSearchField = () => {
    setSearchStatus(false);
    setNotifications(initialNotifications);
    searchInput.current.value = '';
  }

  return (
    <React.Fragment>
      <Grid container spacing={2} direction="row" alignContent="center">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Card
            className={classes.searchContainer}
            style={{ background: '#f4f6f8' }}
          >
            <CardContent>
              <Grid
                container
                alignContent="center"
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs={12} lg={3} xl={3} sm={12} md={12}>
                <Paper elevation={1} className={classes.paper}>
                  <SearchIcon className={classes.searchIcon} />
                  <InputBase inputRef={searchInput} placeholder="Buscar" onKeyPress={ findVehicleKey } />
                  {searchStatus &&
                    <IconButton onClick={ clearSearchField } className={classes.iconButton} aria-label="clear">
                      <DeleteOutlineIcon />
                    </IconButton>
                  }
                </Paper>
                </Grid>
                <Grid item xs={12} lg={2} xl={3} sm={12} md={12}>
                  <Button
                    size="large"
                    variant="contained"
                    color="secondary"
                    onClick={ findVehicle }
                    className={classes.searchButton}
                  >
                    Buscar
                  </Button>
                </Grid>
                <Grid item xs={12} lg={2} xl={3} sm={12} md={12}>
                  {/* <Button
                    fullWidth
                    onClick={handleFilters}
                    size="large"
                    color="secondary"
                    startIcon={<FilterListIcon />}
                    className={classes.filterBtn}
                    variant="outlined"
                  >
                    Filtros
                  </Button> */}
                </Grid>

                <Grid item xs={12} lg={4}>
                  <Button
                    fullWidth
                    component={Link}
                    to="/notifications/create"
                    size="large"
                    variant="contained"
                    color="primary"
                    className={classes.filterBtn}
                  >
                    Crear Nueva Notificación
                  </Button>
                </Grid>
              </Grid>
              {/* FilterButtons */}
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Collapse in={filters}>
            <Card
              className={classes.searchContainer}
              style={{ background: '#f4f6f8' }}
            >
              <CardContent className={classes.cardContent}>
                <Grid
                  container
                  className={classes.header}
                  alignContent="center"
                  alignItems="center"
                >
                  <Grid item>
                    <Typography variant="h6" gutterBottom>
                      Filtros Avanzados &nbsp;
                    </Typography>
                  </Grid>
                  <Grid item>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel htmlFor="outlined-status-native-simple">
                        Estado
                      </InputLabel>
                      <Select
                        native
                        value={state.status}
                        onChange={handleChange}
                        label="Status"
                        inputProps={{
                          name: 'status',
                          id: 'outlined-status-native-simple',
                        }}
                      >
                        <option aria-label="None" value="" />
                        <option value={true}>Activo</option>
                        <option value={false}>Inactivo</option>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Collapse>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        direction="row"
        alignContent="center"
        className={classes.filtersBox}
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Card style={{ background: '#f4f6f8' }}>
            <CardContent>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.th} align="center">
                      ID
                    </TableCell>
                    <TableCell className={classes.th} align="left">
                      Titulo de notificación
                    </TableCell>
                    <TableCell className={classes.th} align="center">
                      Cliente
                    </TableCell>
                    <TableCell className={classes.th} align="center">
                      Fecha de envío
                    </TableCell>
                    <TableCell className={classes.th} align="center">
                      Estado
                    </TableCell>
                    <TableCell className={classes.th} align="center">
                      Acciones
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isLoading && (
                    <TableRow key="skeletonRow" width={100}>
                      <TableCell colSpan="6" align="center">
                        <Skeleton count={5} height={50} />
                      </TableCell>
                    </TableRow>
                  )}
                  {notifications.length <= 0 && !isLoading && (
                    <TableRow key="skeletonRowSinResultados" width={100}>
                      <TableCell colSpan="6" align="center">
                        <h2>Sin Resultados</h2>
                      </TableCell>
                    </TableRow>
                  )}
                  {notifications.map((row) => (
                    <TableRow key={row.NotificacionID}>
                      <TableCell align="center">{row.NotificacionID}</TableCell>
                      <TableCell align="left">{row.Titulo}</TableCell>
                      <TableCell align="center">
                        {row.NombreClientes.map(item => {
                          return item + ' ';
                        })}
                      </TableCell>
                      <TableCell align="center">{moment(row.FechaEnvio, "YYYY-MM-DDTHH:mm:ss").format('DD/MM/YYYY h:mm A')}</TableCell>
                      <TableCell align="center">
                        {row.Enviada ? (
                          <Chip
                            icon={<CheckIcon style={{ color: green[700] }} />}
                            label="Enviada"
                            className={classes.chipActive}
                          />
                        ) : (
                          <Chip
                            icon={<CloseIcon style={{ color: red[700] }} />}
                            label="Sin Enviar"
                            className={classes.chipInactive}
                          />
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="Ver detalle">
                          <IconButton
                            color="secondary"
                            size="small"
                            href={`/notifications/detail/${row.NotificacionID}`}
                            aria-label="see detail"
                          >
                            <ZoomInIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Editar">
                          <IconButton
                            color="secondary"
                            size="small"
                            href={`/notifications/edit/${row.NotificacionID}`}
                            aria-label="edit route"
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
